module.exports = __webpack_public_path__ + "img/app st (5).92e97c55.jpg";